import { render, staticRenderFns } from "./PracticeSumupResultDispEdit.vue?vue&type=template&id=95a64d9c&"
import script from "./PracticeSumupResultDispEdit.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupResultDispEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports